/**
 * Module list bdc
 * @module app.bdc.list
 */
define([
    'angular',
    'modules/bdc/list/controllers/listCtrl',
    'modules/bdc/list/factories/userNetworkService',
    'modules/bdc/list/factories/userNetworkProvider',
    'modules/bdc/list/factories/orderProvider',
    'modules/bdc/list/factories/orderService',
    'modules/bdc/list/factories/clientService',
    'modules/bdc/list/factories/clientProvider',
    'modules/bdc/list/controllers/orderCtrl',
    'modules/bdc/list/factories/orderFormService',
    'modules/bdc/list/factories/pricesService',
    'modules/bdc/list/factories/filtersService',
    'modules/bdc/list/factories/reportRoutingService',
    'modules/bdc/list/factories/electronicSignatureService',
    // 'modules/bdc/list/factories/electronicSignatureProvider',
    'modules/bdc/list/factories/unitBonusService',
    // 'modules/bdc/list/controllers/modals/createBDCFirstStepCtrl',
    'modules/bdc/list/controllers/modals/createUpdateClientCtrl',
    'modules/bdc/list/controllers/modals/deleteOrderCtrl',
    'modules/bdc/list/controllers/modals/signOrderCtrl',
    'modules/bdc/list/controllers/modals/loseOrderCtrl',
    'modules/bdc/list/controllers/modals/abandonedOrderCtrl',
    'modules/bdc/list/controllers/modals/rollbackDateCreatedCtrl',
    'modules/bdc/list/controllers/modals/formOrderContractCtrl',
    'modules/bdc/list/controllers/modals/formOrderTillsCtrl',
    'modules/bdc/list/controllers/modals/formWebTillInfoCtrl',
    'modules/bdc/list/controllers/modals/formOrderWebTillsCtrl',
    'modules/bdc/list/controllers/modals/formConfirmDeleteCtrl',
    'modules/bdc/list/controllers/modals/formTillInfoCtrl',
    'modules/bdc/list/controllers/modals/cancelOrReplaceCtrl',
    'modules/bdc/list/controllers/modals/formCashDrawerInfoCtrl',
    'modules/bdc/list/controllers/modals/formLadditionCtrl',
    'modules/bdc/list/controllers/modals/setOrderReadyForX3IntegrationCtrl',
    'modules/bdc/list/controllers/sectorCtrl',
    'modules/bdc/list/controllers/reportsListCtrl',
    'modules/bdc/list/controllers/modals/jdpOrderCtrl',
    'modules/bdc/list/controllers/modals/pistolGripOrderCtrl',
    'modules/bdc/list/controllers/modals/sponsorOrderCtrl',
], function(angular) {


    /**
     * Configure routing
     * @param $routeProvider
     */
    function bdcHomeRouter($routeProvider) {
        $routeProvider
            .when('/bdc/list/', {
                templateUrl: 'bdc/list/partials/list.html',
                controller: 'ListCtrl',
                controllerAs: 'listCtrl',
                params: {
                    menuTitle: 'Liste des BDC'
                }
            })
            .when('/bdc/order/', {
                templateUrl: 'bdc/list/partials/order.html',
                controller: 'OrderCtrl',
                controllerAs: 'orderCtrl',
                params: {
                    menuTitle: 'BDC'
                }
            });
    }

    bdcHomeRouter.$inject = ['$routeProvider'];

    angular
        .module('app.bdc.list', [
            'app.bdc.list.listCtrl',
            'app.bdc.list.userNetworkService',
            'app.bdc.list.userNetworkProvider',
            'app.bdc.list.orderProvider',
            'app.bdc.list.orderService',
            'app.bdc.list.clientService',
            'app.bdc.list.clientProvider',
            'app.bdc.list.orderCtrl',
            'app.bdc.list.orderFormService',
            'app.bdc.list.pricesService',
            'app.bdc.list.reportRoutingService',
            'app.bdc.list.filtersService',
            'app.bdc.list.electronicSignatureService',
            // 'app.bdc.list.electronicSignatureProvider',
            // 'app.bdc.list.createBDCFirstStepCtrl',
            'app.bdc.list.createUpdateClientCtrl',
            'app.bdc.list.deleteOrderCtrl',
            'app.bdc.list.signOrderCtrl',
            'app.bdc.list.loseOrderCtrl',
            'app.bdc.list.abandonedOrderCtrl',
            'app.bdc.list.rollbackDateCreatedCtrl',
            'app.bdc.list.formOrderContractCtrl',
            'app.bdc.list.formOrderTillsCtrl',
            'app.bdc.list.formConfirmDeleteCtrl',
            'app.bdc.list.formTillInfoCtrl',
            'app.bdc.list.cancelOrReplaceCtrl',
            'app.bdc.list.formCashDrawerInfoCtrl',
            'app.bdc.list.formLadditionCtrl',
            'app.bdc.list.sectorCtrl',
            'app.bdc.list.reportsListCtrl',
            'app.bdc.list.formOrderWebTillsCtrl',
            'app.bdc.list.formWebTillInfoCtrl',
            'app.bdc.list.setOrderReadyForX3IntegrationCtrl',
            'app.bdc.list.unitBonusService',
            'app.bdc.list.jdpOrderCtrl',
            'app.bdc.list.pistolGripOrderCtrl',
            'app.bdc.list.sponsorOrderCtrl',
        ])
        .config(bdcHomeRouter);
});
